<template>
    <div>
        Currently Under Constrcution
        <button @click='emitCancel()'>Cancel</button>
    </div>
</template>

<script>
export default {
    props: [
        'user'
    ],
    methods: {
        emitCancel: function (){
            let vm = this;
            vm.$emit('cancelprofile')
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Profile/Profile.vue